import React from 'react';
import { EVENT_SCHEDULE_TAB_MINE, EVENT_SCHEDULE_TAB_PROGRAM, EVENT_SCHEDULE_TAB_SEARCH, EVENT_SCHEDULE_TAB_TAGGED, EVENT_SCHEDULE_TAB_TASKS } from '../../schedule-header-tabs';
import ScheduleMine from './ScheduleMine';
import ScheduleProgram from './ScheduleProgram';
import ScheduleSearch from './ScheduleSearch';
import ScheduleTagged from './ScheduleTagged';
import ScheduleTasks from './ScheduleTasks';

function ScheduleTabContent(props) {
    const { tab, ...otherProps } = props;

    switch (tab) {
        case EVENT_SCHEDULE_TAB_MINE:
            return <ScheduleMine {...otherProps} />;
        case EVENT_SCHEDULE_TAB_TASKS:
            return <ScheduleTasks {...otherProps} />;
        case EVENT_SCHEDULE_TAB_TAGGED:
            return <ScheduleTagged {...otherProps} />;
        case EVENT_SCHEDULE_TAB_SEARCH:
            return <ScheduleSearch {...otherProps} />;
        case EVENT_SCHEDULE_TAB_PROGRAM:
        default:
            return <ScheduleProgram {...otherProps} />;
    }
}

export default ScheduleTabContent;
